import { resolveExtensionNamespace } from './resolve-extension-namespace.js'

export function resolveSchemaActionImportPath(
  schemaName: string,
  outputNamespace?: string
): string {
  const namespace = resolveExtensionNamespace(schemaName, outputNamespace)
  if (namespace === 'core') {
    return schemaName
  }

  return namespace === schemaName ? schemaName : `${namespace}/${schemaName}`
}
